import stock from '@/api/stock/stock-return'
import moment from 'moment'
import { join, isEmpty } from 'lodash'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  branch_id: [],
  locationId: [],
  dateRange: [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')],
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_BRANCH_ID(state, value) {
    state.branch_id = value
  },
  SET_LOCATION_ID(state, locationIds) {
    state.location_id = locationIds
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search,
          location_id: context.state.location_id,
          date_between: join(context.state.dateRange, ','),
        }
      },
      attrubutes
    )
    return stock.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return stock.store(data)
  },
  update(context, { id, data }) {
    return stock.update(id, data)
  },
  async find(context, id) {
    if (isEmpty(context.state.edit_data)) {
      let response = await stock.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, { id, data }) {
    return stock.destroy(id, data)
  },
  findProduct(context, attributes = {}) {
    return stock.findProduct({ params: attributes })
  },
  getCustomer(context, id) {
    return stock.getCustomer(id)
  },
  getEmployee(context) {
    return stock.getEmployee()
  },
  reprint(context, id) {
    return stock.reprint(id)
  },
}
